/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Type of PDP breadcrumb
 */
export enum BreadcrumbType {
  HOMEPAGE = 'homepage',
  LICENSED = 'licensed',
  ARTIST = 'artist',
  COLLECTION = 'collection',
  POSTER = 'poster',
}
